import { Injectable } from '@angular/core';
// import for web
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { EnvironmentProvider } from '@core-modules/providers/environment-variables/environment';
import { AnalyticsUserProperties } from '../enums/analytics-user-properties';


/*
  Generated class for the NewsProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable({
    providedIn: 'root'
})
export class CoreAnalytics
{
    //#region Constructor

    /**
     * Class constructor
     * @param {Platform} platform
     * @param {EnvironmentProvider} env
     */
    constructor
        (
            private env: EnvironmentProvider
        )
    {
    }

    //#endregion


    //#region Methods

    /**
     * Initializes the provider
     * @param platform 
     */
    public async InitializeAnalyticsService(platform: string)
    {
        if (platform == "web")
        {
            await FirebaseAnalytics.initializeFirebase(this.env.firebaseConfig);
        }

        // If the environment is set to track usage then enable the 
        // analytics. Otherwise disable them.
        if (this.env.trackUsage)
        {
            await FirebaseAnalytics.enable();

        } else
        {
            await FirebaseAnalytics.disable();
        }
    }

    /**
     * set user properties for analytics
     * @param key identification from enum
     * @param value
     */
    public SetUserProperty(key: AnalyticsUserProperties, value: string)
    {
        return FirebaseAnalytics.setUserProperty({ name: key, value: value });
    }

    /**
     * set user identity through hash for analytics
     * @param clientHash
     */
    public SetUserId(clientHash: string)
    {
        return FirebaseAnalytics.setUserId({ userId: clientHash });
    }

    /**
     * Track an analytics event
     * @param event
     * @param params
     */
    public TrackEvent(event: string, params: { [id: string]: string | boolean | string[] } = {}): void
    {
        if (this.env.trackUsage)
        {
            FirebaseAnalytics.logEvent({
                name: event,
                params: params
            });
        }
    }

    /**
     * Track screen transitions
     * @param screenName name of the screen
     */
    public TrackScreen(screenName: string): void
    {
        if (this.env.trackUsage)
        {
            FirebaseAnalytics.setScreenName({
                screenName: screenName,
                nameOverride: screenName,
            });
        }
    }

    //#endregion
}